module.exports = __webpack_public_path__ + "img/22-03.7ebab330.png";